class Accordion {
	constructor(wrapper) {
		this.wrapper = wrapper;

		this.isOnlyMobileAccordion = false;

		if (wrapper) {
			this.initAccordion();
		}
	}

	initAccordion() {
		this.isOnlyMobileAccordion = this.wrapper.dataset.onlyMobileAccordion;

		if (this.isOnlyMobileAccordion === 'true') {
			const buttons = this.wrapper.querySelectorAll('.js-accordion__button');
			this.handleOnlyMobileAccordion();
			buttons.forEach((button) => {
				button.addEventListener('click', this.toggleAccordionSection.bind(this));
			});
		} else {
			/*
			* This uses event delegation, since the event is still attached on desktop
			* if isOnlyMobileAccordion, this can't be used there because would need to destroy
			* and create the event each time, if not, NVDA will mention as a clickable section.
			* TODO: check what is better:
			* - Destroy and recreate event listener (this would only occur on resize)
			* - Don't use event delegation
			*/
			this.wrapper.addEventListener('click', this.toggleAccordionSection.bind(this));
		}
	}

	// eslint-disable-next-line class-methods-use-this
	toggleAccordionSection(event) {
		if (event.target.classList.contains('js-accordion__button')) {
			const button = event.target;
			let section;
			const moreLabel = button.querySelector('.js-accordion_more');
			const lessLabel = button.querySelector('.js-accordion_less');

			if (event.target.parentElement.classList.contains('js-accordion__button-wrapper')) {
				section = event.target.parentElement.nextElementSibling;
			} else {
				section = event.target.nextElementSibling;
			}

			if (button.getAttribute('aria-expanded') === 'false') {
				if (moreLabel && lessLabel) {
					lessLabel.classList.remove('hide');
					moreLabel.classList.add('hide');
				}
				button.setAttribute('aria-expanded', 'true');
				section.classList.remove('is-hidden');
			} else {
				if (moreLabel && lessLabel) {
					lessLabel.classList.add('hide');
					moreLabel.classList.remove('hide');
				}
				button.setAttribute('aria-expanded', 'false');
				section.classList.add('is-hidden');
			}
		}
	}

	handleOnlyMobileAccordion() {
		const sections = this.wrapper.querySelectorAll('.js-accordion__section');

		const mobileBreakpoint = window.matchMedia('(min-width: 992px)');

		if (window.innerWidth >= 992) {
			this.removeAccordionA11yAttributes(sections);
		} else {
			this.addAccordionA11yAttributes(sections);
		}

		// Safari Webkit has this bug and it fails on iOS 13 because `addEventListener`
		// doesn't work on `matchMedia`.
		// https://bugs.webkit.org/show_bug.cgi?id=203288
		if (!mobileBreakpoint.addEventListener) {
			mobileBreakpoint.addEventListener = (type, fn) => mobileBreakpoint.addListener(fn);
		}

		mobileBreakpoint.addEventListener('change', (event) => {
			if (event.matches) {
				this.removeAccordionA11yAttributes(sections);
			} else {
				this.addAccordionA11yAttributes(sections);
			}
		});
	}

	// eslint-disable-next-line class-methods-use-this
	removeAccordionA11yAttributes(sections) {
		sections.forEach((section) => {
			section.removeAttribute('id');
			section.removeAttribute('role');
			section.removeAttribute('aria-labelledby');
		});
	}

	// eslint-disable-next-line class-methods-use-this
	addAccordionA11yAttributes(sections) {
		sections.forEach((section) => {
			section.setAttribute('id', section.dataset.id);
			section.setAttribute('role', section.dataset.role);
			section.setAttribute('aria-labelledby', section.dataset.ariaLabelledby);
		});
	}
}

export default Accordion;
